import React from "react";
import { useNavigate } from "react-router-dom";
import { reopenCompletedCampaign } from "../../../utils/campaignViewActions";

/**
 * CompletedActions — re-open a finished raise, on a NEW schedule.
 *
 * OWNER DECISION 4 (2026-08-09). A completed campaign previously had no admin
 * route back at all: `completed` shared the `read-only` viewType with rejected,
 * closed, draft, cancelled and deleted, and ReadOnlyActions renders `null`.
 * It now has its own viewType so this panel reaches ONLY completed campaigns —
 * remapping `read-only` itself would have handed a Re-open button to deleted and
 * rejected campaigns as well.
 *
 * The only offered transition is COMMING_SOON (9) with a new future launch date.
 * Direct COMPLETED -> APPROVED is refused by the api with a named 409, because
 * a completed campaign necessarily carries a launchDate in the past and would go
 * live the same instant. This panel is the explanation; the server is the
 * enforcement.
 *
 * The previous closing, refunds, payouts and investment history are untouched.
 *
 * Backend: update-campaign-status (superAdmin.controller.js)
 */
const CompletedActions = ({ campaign, campaignId, canEdit }) => {
  const navigate = useNavigate();
  const resolvedCampaignId = campaignId || campaign?.data?.[0]?.id;

  // No page-level loader here, matching PausedActions: confirmAction renders
  // SweetAlert's own inline spinner, and raising the page loader covers the
  // dialog (z 1060 under z 99999) and swallows the click.
  const handleReopen = async () => {
    const result = await reopenCompletedCampaign(resolvedCampaignId);
    if (result.success && result.navigateTo) navigate(result.navigateTo);
  };

  return (
    <div className="left">
      <h1 className="title">Campaign Actions (Completed)</h1>
      <p style={{ marginTop: "6px", marginBottom: "10px", fontSize: "14px", color: "#555" }}>
        This raise is finished. Re-opening it schedules a new one — it returns as
        Coming Soon and goes live on the date you choose. The previous closing and
        its investment history are kept.
      </p>
      {canEdit !== false && (
      <div style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>
        <button className="approveButton" onClick={handleReopen}>
          Re-open with a new launch date
        </button>
      </div>
      )}
    </div>
  );
};

export default CompletedActions;
